// extracted by mini-css-extract-plugin
export default {"toggleLabel":"Style_toggleLabel__19nk7","switch":"Style_switch__WV7kQ","slider":"Style_slider__endb1"};